export const data=[
    {
        imgSrc:require('../../../assets/bubbles.png'),
        code:`import {BubbleChart} from 'react-native-gifted-charts';

const App = () => {
  const data = [
    {x: 10, y: 15},
    {x: 15, y: 8},
    {x: 20, y: 12},
    {x: 25, y: 14},
  ];
  return <BubbleChart data={data} />;
};`
    },
    {
        imgSrc:require('../../../assets/bubblesVar.png'),
        code:`import {BubbleChart} from 'react-native-gifted-charts';

const App = () => {
  const data = [
    {x: 10, y: 15, r: 12},
    {x: 15, y: 8, r: 15},
    {x: 20, y: 12, r: 25},
    {x: 25, y: 14, r: 16},
  ];
  return <BubbleChart data={data} />;
};`
    },
    {
        imgSrc:require('../../../assets/bubbleLabelled.png'),
        code:`import {BubbleChart} from 'react-native-gifted-charts';

const App = () => {
  const data = [
    {x: 10, y: 15, r: 12},
    {x: 15, y: 8, r: 15},
    {x: 20, y: 12, r: 25},
    {x: 25, y: 14, r: 16},
  ];
  return (
    <BubbleChart
      data={data}
      showValuesAsBubbleLabels
      labelFontSize={14}
    />
  );
};`
    },
    {
        imgSrc: null,
        code:`interface RegressionLineConfig {
  thickness?: number
  color?: ColorValue
  opacity?: number
  strokeDashArray?: number[]
  isAnimated?: boolean
  animationDuration?: number
  x1?: number
  x2?: number
  y1?: number
  y2?: number
}`
    },
    {
        imgSrc: null,
        code:`interface DataSetForBubbleChart {
  data: bubbleDataItem[];
  showRegressionLine?: boolean;
  regressionLineConfig?: RegressionLineConfig;
  seriesBubblesColor?: ColorValue;
  seriesBubblesBorderColor?: ColorValue;
}`
    },
    {
        imgSrc: null,
        code:`const getX = (index: number): number => {
  const val =
    props.data?.[index].x !== undefined
      ? (props.data?.[index].x ?? 0) * xScale
      : Math.min(
          totalWidth - (props.data?.[index].r ?? BubbleDefaults.bubblesRadius),
          ((index + 1) * totalWidth) / (props.data?.length ?? 1),
        );
  return val;
};`
    },
]